export enum TypeProduct {
  NONE = "none",
  LINK = "link",
  MANUAL = "manual",
  PREVIOUS = "previous",
}

export const MAX_IMAGES = 5;
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB

export const FOLDER_IMAGES = "onboarding-products";